import { createApp } from 'vue'
import App from './App.vue'

import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import router from './router'
import store from './store';
import DOMPurify from 'dompurify';


const app = createApp(App);

// Shared rich-text renderer: sanitize any raw TinyMCE HTML before injecting it.
// Usage: <div v-safe-html="someHtmlField" /> (drop-in replacement for v-html).
const renderSafeHtml = (el, binding) => {
    el.innerHTML = DOMPurify.sanitize(binding.value == null ? '' : String(binding.value));
};
app.directive('safe-html', {
    mounted: renderSafeHtml,
    updated: renderSafeHtml,
});

app.use(router).use(store).mount('#app');
